import {
  makeStyles,
  Snackbar,
} from "@material-ui/core";
import { Add as AddIcon } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";
import { useDispatch, useSelector } from "react-redux";

import { TextField } from "@material-ui/core";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BCService from "../../services/BC";

// import {
//   getAllWarehousesManager,

//   addNewRealWarehouse,
// } from "../reduxSaga/actions";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "fixed",
    bottom: 20,
    right: 20,
  },
  container: {
    borderRadius: 10,
    boxShadow: "0 3px 5px 2px rgba(18,131,255,0.87)",
    width: 500,
    height: 300,
    backgroundColor: "white",
    position: "absolute",
    top: -30,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "100vw",
      height: "100vh",
    },
  },
  form: {
    padding: theme.spacing(2),
  },
  item: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(3),
  },

  cancelAndAddButtom: {
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(5),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  input: {
    "&::placeholder": {
      fontStyle: "italic",
    },
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const AddPayement = ({ idPayementInfo, setOnAddPayement }) => {


  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [dateOperation, setDateOperation] = useState();
  const [dateValeur, setDateValeur] = useState();

  const [ref, setRef] = useState();
  const [desc, setDesc] = useState();


  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onChangeRef = (event) => {
    setRef(event.target.value);
  };

  const onChangeDesc = (event) => {
    setDesc(event.target.value);
  };

  const onCancelButtonHandler = () => {
    setOpen(false);
    setOnAddPayement(false);
  };

  const onAddBrand = () => {
    if (ref == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le champ du non est vide ! ");
    } else {
      let payementModel = {
        idPayementInfo: idPayementInfo,
        ref: ref,
        description: desc,
        dateOperation: dateOperation,
        dateValeur: dateValeur,
        idUserCreation: getCurrentUserId(),
        typePayement: "accept",
      };
      BCService.PayRejeterPayementInfo(payementModel)
        .then((response) => {
          if (response.data["error"]) {
            toast.error("Error : il ya un probléme");
          } else {
            toast.success("ajouté avec succès");
            window.location.reload(false);

            // this.refreshPage();
          }
        })
        .catch((error) => {
          toast.error("Error : il ya un probléme");
          window.location.reload(false);

          // this.refreshPage();
        });
    }
  };

  const changeDateOperation = (event) => {
    setDateOperation(event.target.value.concat(":59"))
  }
  const changeDateValeur = (event) => {
    setDateValeur(event.target.value.concat(":59"))

  }

  return (
    <>
      <ToastContainer />

      <div class="modal fade" id="add-payement">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-black">
              <h4 class="modal-title">Valider le payement</h4>
            </div>
            <div class="modal-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputName">Référence</label>
                    <input
                      placeholder="Référence"
                      onChange={onChangeRef}
                      type="text"
                      id="inputName"
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="form-group col-sm-6">
                  <label>Date Opération </label>
                  <br />
                  <TextField
                    style={{ width: "100%" }}
                    className="col-sm-12"
                    variant="outlined"
                    value={dateOperation}
                    onChange={changeDateOperation}
                    id="datetime-local"
                    type="datetime-local"
                    defaultValue="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    size="small"
                  />
                </div>
                <div className="form-group col-sm-6">
                  <label>Date Valeur </label>
                  <br />
                  <TextField
                    style={{ width: "100%" }}
                    className="col-sm-12"
                    variant="outlined"
                    value={dateValeur}
                    onChange={changeDateValeur}
                    id="datetime-local"
                    type="datetime-local"
                    defaultValue="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    size="small"
                  />
                </div>
              </div>


              <div className="row">
                <div className="form-group col-sm-12">
                  <label htmlFor="inputDescription">Description</label>
                  <textarea
                    placeholder="Saisir..."
                    onChange={onChangeDesc}
                    id="inputDescription"
                    className="form-control"
                    rows={2}
                  />
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button
                type="button"
                onClick={onCancelButtonHandler}
                class="btn btn-light"
                data-dismiss="modal"
              >
                Close
              </button>

              <button type="button" onClick={onAddBrand} class="btn btn-light">
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={openAlert}
        autoHideDuration={2000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleClose} severity="success">
          Ajout avec success !
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddPayement;
